<app-chart-wrapper [title]="'Write-Offs'" [showTotal]="true" [total]="'1000'" [showExpandIcons]="false">
    <app-chart-filter filter [form]="writeOffForm" [formControls]="writeOffFormControls" (filter)="filterWriteOffs($event)"></app-chart-filter>
    <app-doughnut-chart chart></app-doughnut-chart>
</app-chart-wrapper>